import React, { useState } from 'react';
import { ButtonV2, Flex, TextV2 } from '@withjoy/joykit';
import { useTextLineClampOverflow } from '@shared/hooks/useTextLineClampOverflow';
import { useTranslation } from '@shared/core';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { pxToRem } from '@withjoy/joykit/theme';
import { TextEllipsisWrapper } from '@shared/utils/formatting/textEllipsis';

export const UserNote = ({ note }: { note: string }) => {
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const { textRef, isOverflowing } = useTextLineClampOverflow(1);
  const { t } = useTranslation('accommodationsConsole');
  const listingsPanelTrans = t('listingsPanel');

  const handleDescriptionOpen = useEventCallback((e: React.MouseEvent) => {
    e.preventDefault();
    setIsDescriptionOpen(isOpen => !isOpen);
  });

  return (
    <Flex
      alignItems="end"
      marginY={3}
    >
      <TextEllipsisWrapper
        ref={textRef}
        lineClamp={isDescriptionOpen ? 'none' : 1}
        lineHeight={pxToRem(24)}
      >
        <TextV2
          typographyVariant="body1"
          fontSize={pxToRem(13)}
          color={'mono10'}
          fontStyle={'italic'}
          lineHeight={pxToRem(24)}
        >
          {note}
        </TextV2>
      </TextEllipsisWrapper>
      {isOverflowing && (
        <ButtonV2
          onClick={handleDescriptionOpen}
          typographyVariant="button2"
          fontWeight={400}
          intent="neutral"
          variant="ghost"
          fontSize={pxToRem(13)}
          color={'mono10'}
          fontStyle={'italic'}
          textDecoration="solid"
          textDecorationLine="underline"
          css={{ ['text-underline-offset']: pxToRem(3) }}
          width="fit-content"
          padding={0}
          marginLeft={4}
          height={'fit-content'}
        >
          {isDescriptionOpen ? listingsPanelTrans.readLess() : listingsPanelTrans.readMore()}
        </ButtonV2>
      )}
    </Flex>
  );
};
